import { inject, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { APP_CONFIG } from '../config/app-config.token';
import { SentryErrorContext } from '@klubovna/shared-models';

@Injectable({
  providedIn: 'root',
})
export class SentryLoggerService {
  private config = inject(APP_CONFIG);

  captureException(error: any, context: SentryErrorContext): void {
    if (this.config.sentryLogging) {
      Sentry.captureException(error, {
        tags: {
          component: context.component,
          action: context.action,
        },
        extra: {
          errorMessage: error?.message,
          status: error?.status,
          url: error?.url,
          ...context.extra,
        },
      });
    }
  }

  captureMessage(message: string, level: 'error' | 'warning' | 'info' = 'info', context: SentryErrorContext): void {
    if (this.config.sentryLogging) {
      Sentry.captureMessage(message, {
        level,
        tags: {
          component: context.component,
          action: context.action,
        },
        extra: context.extra,
      });
    }
  }

  captureHttpError(error: any, context: SentryErrorContext): void {
    if (this.config.sentryLogging) {
      const normalizedError = new Error(`HTTP ${ error?.status || 'unknown' }: ${ error?.message || error?.statusText || 'Request failed' }`);
      normalizedError.name = 'HttpError';

      Sentry.captureException(normalizedError, {
        tags: {
          component: context.component,
          action: context.action,
          errorType: 'http_error',
          httpStatus: String(error?.status || 'unknown'),
        },
        extra: {
          originalError: error?.error,
          httpStatus: error?.status,
          httpStatusText: error?.statusText,
          httpUrl: error?.url,
          ...context.extra,
        },
      });
    }
  }
}
